import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { MANUAL_PRICE_NAME, MANUAL_RATE_NAME, PRODUCT_NAME } from './ContractBuy';
import { TextField, ListItem, Grid } from '@material-ui/core';
import DefaultButton from '../../../components/Button/DefaultButton';
import LoadingIndicator from '../../../components/LoadingIndicator/LoadingIndicator';

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 32px 32px 32px;
  width: 550px;
  .contract_list {
    padding-bottom: 24px;
  }
  .inner_box {
    max-width: 450px;
    display: grid;
    padding: 0 14px;
    .product_select {
      width: 440px;
      margin-bottom: 34px;
    }
    .price_rate_box {
      display: flex;
      justify-content: space-between;
      width: 100%;
      div {
        max-width: 220px;
      }
    }
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 32px;
  padding-right: 20px;
`;

export const BuyMultipleContracts = ({
  chosenContracts,
  confirmBtnTitle,
  cancelBtnTitle,
  setIsModalOpen,
  productsData,
  postProducts,
  setOpen,
  postLoading,
  inputErrors,
  getProducts,
  getLoading,
  handleSubmit,
  register,
}) => {
  const intl = useIntl();
  const dataMissing = intl.formatMessage({ id: 'app.data.missing' });
  const [currentProduct, setCurrentProduct] = useState('');
  const [currentPrice, setCurrentPrice] = useState('');
  const [currentRate, setCurrentRate] = useState('');
  const [editable, setEditable] = useState(true);

  const handleProductChange = (event) => {
    const product = productsData?.products[event.target.value];
    setCurrentProduct(product);
    setCurrentPrice(product?.priceEUR);
    setCurrentRate(productsData?.rate);
  };

  const handleSend = (idButton) => {
    setEditable(!editable);
    if (idButton !== 'cancel') {
      const postData = {
        contracts: chosenContracts.map((item) => {
          return item?.id;
        }),
        product: currentProduct.id,
        price: currentPrice,
        rate: currentRate,
      };
      postProducts(postData);
      setOpen(true);
    }
    setIsModalOpen(false);
  };

  useEffect(() => {
    const commodityId = chosenContracts[0]?.commodityId;
    const contractPeriod = chosenContracts[0]?.contractPeriod;
    if (commodityId && contractPeriod) {
      getProducts(commodityId, contractPeriod);
    }
  }, [getProducts, chosenContracts]);

  return (
    <>
      {getLoading && <LoadingIndicator />}
      <form onSubmit={handleSubmit(handleSend)}>
        <Layout>
          <Grid className={'contract_list'} container>
            {chosenContracts &&
              chosenContracts.map((contract) => (
                <Grid key={contract.idExternal} item xs={4}>
                  <ListItem>{contract.idExternal}</ListItem>
                </Grid>
              ))}
          </Grid>
          <div className={'inner_box'}>
            <TextField
              className={'product_select'}
              name={PRODUCT_NAME}
              select
              required
              label={intl.formatMessage({ id: 'app.products.product' })}
              SelectProps={{
                native: true,
              }}
              variant="outlined"
              onChange={(event) => handleProductChange(event)}>
              <option key={`product-empty`} value={null} />
              {productsData?.products.map((product, index) => (
                <option key={product.id} value={index}>
                  {product.exchangeProductName}
                </option>
              ))}
            </TextField>
            <div className={'price_rate_box'}>
              <TextField
                name={MANUAL_PRICE_NAME}
                onChange={(event) => {
                  setCurrentPrice(event.target.value);
                }}
                type="number"
                variant="outlined"
                label={intl.formatMessage({ id: 'app.price' })}
                value={currentPrice || ''}
                disabled={!editable}
                inputRef={register({
                  required: dataMissing,
                })}
                helperText={!currentPrice && inputErrors[MANUAL_PRICE_NAME]?.message}
                error={!currentPrice && !!inputErrors[MANUAL_PRICE_NAME]}
              />
              <TextField
                name={MANUAL_RATE_NAME}
                onChange={(event) => {
                  setCurrentRate(event.target.value);
                }}
                type="number"
                variant="outlined"
                label={intl.formatMessage({ id: 'app.exchangeRate' })}
                value={currentRate || ''}
                disabled={!editable}
                inputRef={register({
                  required: dataMissing,
                })}
                helperText={!currentRate && inputErrors[MANUAL_RATE_NAME]?.message}
                error={!currentRate && !!inputErrors[MANUAL_RATE_NAME]}
              />
            </div>
          </div>
          <ButtonWrapper>
            <DefaultButton
              id={'cancel'}
              primary={false}
              disabled={!editable}
              title={cancelBtnTitle}
              onClick={(event) => {
                handleSend(event.currentTarget.id);
              }}
            />
            <DefaultButton primary={true} disabled={!editable} type="submit" title={confirmBtnTitle} loaders={[postLoading]} />
          </ButtonWrapper>
        </Layout>
      </form>
    </>
  );
};

BuyMultipleContracts.propTypes = {
  chosenContracts: PropTypes.array,
  confirmBtnTitle: PropTypes.string,
  cancelBtnTitle: PropTypes.string,
  setIsModalOpen: PropTypes.func,
  productsData: PropTypes.object,
  postProducts: PropTypes.func,
  setOpen: PropTypes.func,
  postLoading: PropTypes.bool,
  inputErrors: PropTypes.object,
  getProducts: PropTypes.func,
  getLoading: PropTypes.bool,
  handleSubmit: PropTypes.func,
  register: PropTypes.func,
};
